var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.061615 0 0 .061615 -1.430818 -1.2754)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500h319.5zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.3 779.7L520 939.5 959.4 500H639.9z",
    fill: "#39cefd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500h319.5zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#D)",
    d: "M639.9 20.7h319.5l-679 679.1L120.6 540z",
    fill: "#39cefd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500h319.5zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#F)",
    d: "M520 939.5l119.9 119.8h319.5L679.8 779.7z",
    fill: "#03569b"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500h319.5zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 566.635,
    y1: 970.339,
    x2: 685.65,
    y2: 851.324
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#H)",
    d: "M757 857.4l-77.2-77.7L520 939.5z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500h319.5zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#J"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.282 779.645L520.086 619.84 679.9 779.645 520.086 939.45z",
    fill: "#16b9fd"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "L",
    cx: 7824.659,
    cy: -2855.979,
    r: 5082.889,
    gradientTransform: "matrix(0.25,0,0,-0.25,-1812,-622.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M959.4 500L679.8 779.7l279.6 279.7H639.9L360.2 779.7 639.9 500h319.5zM639.9 20.7L120.6 540l159.8 159.8 679-679.1H639.9z",
    fill: "url(#L)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.6a0a2e6200396ba839c9c91a9b016eac.svg";
export { ForwardRef as ReactComponent };